export function getYearBlockIndex(yearsMatrix: number[][], year = -1): number {
  return yearsMatrix.reduce((acc, yearArray, yearArrayIndex) => {
    if (year && yearArray.includes(year)) {
      acc = yearArrayIndex;
    }

    return acc;
  }, 0);
}
